import { ViewTypeItem } from 'models/chanelModel';
import { LanguageItem } from 'models/languageModel';
import { MenuChanel, MenuCountryPartner } from 'models/menuModel';

// export const menuHeader: MenuChanel[] = [
//     {
//         name: 'vietnam',
//         icon: require('assets/images/flag/vietnam.png'),
//         subMenu: [
//             {
//                 name: 'all',
//                 value: -1,
//             },
//             {
//                 name: 'vip',
//                 value: 0,
//             },
//             {
//                 name: 'asian 24h',
//                 value: 1,
//             },
//             {
//                 name: 'southern',
//                 value: 4,
//             },
//             {
//                 name: 'central',
//                 value: 3,
//             },
//             {
//                 name: 'northern',
//                 value: 2,
//             },
//         ],
//     },

//     {
//         name: 'china',
//         icon: require('assets/images/flag/china.png'),
//         subMenu: [
//             {
//                 name: 'all',
//                 value: -1,
//             },
//             {
//                 name: 'vip',
//                 value: 0,
//             },
//         ],
//     },
//     {
//         name: 'thailand',
//         icon: require('assets/images/flag/thailan.png'),
//         subMenu: [
//             {
//                 name: 'all',
//                 value: -1,
//             },
//             {
//                 name: 'vip',
//                 value: 0,
//             },
//         ],
//     },
//     {
//         name: 'lao',
//         icon: require('assets/images/flag/lao.png'),
//         subMenu: [
//             {
//                 name: 'all',
//                 value: -1,
//             },
//             {
//                 name: 'vip',
//                 value: 0,
//             },
//         ],
//     },
//     {
//         name: 'singapore',
//         icon: require('assets/images/flag/singapore.png'),
//         subMenu: [
//             {
//                 name: 'all',
//                 value: -1,
//             },
//             {
//                 name: 'vip',
//                 value: 0,
//             },
//         ],
//     },
//     {
//         name: 'malaysia',
//         icon: require('assets/images/flag/malaysia.png'),
//         subMenu: [
//             {
//                 name: 'all',
//                 value: -1,
//             },
//             {
//                 name: 'vip',
//                 value: 0,
//             },
//         ],
//     },
//     {
//         name: 'philippines',
//         icon: require('assets/images/flag/philippine.png'),
//         subMenu: [
//             {
//                 name: 'all',
//                 value: -1,
//             },
//             {
//                 name: 'VIP',
//                 value: 0,
//             },
//         ],
//     },
// ];

export const menuCountryPartners: MenuCountryPartner[] = [
    {
        name: 'China',
        icon: require('assets/images/flag/china.png'),
        code: 'cn',
        partners: []
    },
    {
        name: 'Vietnam',
        icon: require('assets/images/flag/vietnam.png'),
        code: 'vi',
        partners: []
    },
    {
        name: 'Malaysia',
        icon: require('assets/images/flag/malaysia.png'),
        code: 'malay',
        partners: []
    },
    {
        name: 'Thailand',
        icon: require('assets/images/flag/thailan.png'),
        code: 'thailand',
        partners: []
    },
    {
        name: 'Singapore',
        icon: require('assets/images/flag/singapore.png'),
        code: 'sing',
        partners: []
    },
    {
        name: 'Philippine',
        icon: require('assets/images/flag/philippine.png'),
        code: 'philip',
        partners: []
    },
    {
        name: 'Laos',
        icon: require('assets/images/flag/lao.png'),
        code: 'laos',
        partners: []
    },

];

export const menuHeader: MenuChanel[] = [
    {
        name: 'home',
        route: 'home',
        icon: require('assets/images/flag/vietnam.png'),
        subMenu: [
            {
                name: 'all',
                value: -1,
            },
            {
                name: 'vip',
                value: 0,
            },
            {
                name: 'asian',
                value: 1,
            },
            {
                name: 'southern',
                value: 4,
            },
            {
                name: 'central',
                value: 3,
            },
            {
                name: 'northern',
                value: 2,
            },
        ],
    },
    {
        name: 'partners',
        route: 'partners',
        icon: require('assets/images/flag/vietnam.png'),
        subMenu: [],
    },
    {
        name: 'api',
        route: 'api',
        icon: require('assets/images/flag/vietnam.png'),
        subMenu: [],
    },
    {
        name: 'contact us',
        route: 'contact',
        icon: require('assets/images/flag/vietnam.png'),
        subMenu: [],
    },
];

export const languageList: LanguageItem[] = [
    {
        name: 'English',
        value: 'en',
        image: require('assets/images/flag/uk.png'),
    },
    {
        name: 'Tiếng Việt',
        value: 'vi',
        image: require('assets/images/flag/vietnam.png'),
    },
    {
        name: 'China',
        value: 'cn',
        image: require('assets/images/flag/china.png'),
    },
];

export const listViewType: ViewTypeItem[] = [
    {
        view: 'NORMAL',
        text: 'normal',
    },
    {
        view: '2NUMBER',
        text: '2number',
    },
    {
        view: '3NUMBER',
        text: '3number',
    },
];
